<img
  [src]="user().avatar"
  [alt]="user().name"
  class="border-accent-900 size-11 shrink-0 rounded-full border bg-neutral-400 object-cover object-center" />

<div class="min-w-10 grow md:max-w-24">
  <p class="preset-body-3 md:preset-body-1 truncate text-neutral-50">{{ user().name }}</p>
  <p class="preset-body-4 md:preset-body-2 text-accent-900 truncate capitalize">{{ user().escuderia.name }}</p>
</div>

<coins-badge
  [coins]="user().points || 0"
  [showType]="false" />
